import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export const gourmetMenuSlider = () => {
  const root = document.querySelector(".js-gourmet-menu-slider");
  if (!root) return;

  new Splide(root, {
    type: "loop",
    arrows: false,
    pagination: false,
    drag: true,
    gap: 0,
    fixedWidth: "20rem",
    autoScroll: {
      speed: 0.3,
      pauseOnHover: true,
    },
    breakpoints: {
      1024: {
        autoScroll: {
          speed: 0.5,
        },
      },
    },
  }).mount({ AutoScroll });
};
